import React, { useState, useEffect } from "react";
import ReactJson from "react-json-view";
import _ from "lodash";
import { useDebouncedValue } from "@mantine/hooks";

import {
  Checkbox,
  Table,
  NumberInput,
  Button,
  ActionIcon,
  Select,
  Text,
  Tabs,
  Group,
  Center,
} from "@mantine/core";
import RemoteSelect2 from "./remoteSelect2";
import { IconTrash, IconCirclePlus, IconCircleX } from "@tabler/icons";
import {
  DATA_MARIAGE_STATUS,
  DATA_OVERRIDING_LEVEL_TYPE,
} from "../data/options";

import { useFormatter } from "../hooks/useFomatter";
import { useTranslation } from "react-i18next";
import OverridingTable from "./overridingTable";
const OverridingTables = ({ form: mainForm, name, size = "md" }) => {
  const { t } = useTranslation();

  const defaultTable = _.get(mainForm.values, "table");
  const specialTables = _.get(mainForm.values, "specialTables");

  const handleAddTable = () => {
    console.log(defaultTable);
    console.log(specialTables);

    // specialTables.push(...defaultTable);
    mainForm.setFieldValue("specialTables", [
      ...specialTables,
      {
        rows: [...defaultTable],
        name: "VARIATION " + (specialTables.length + 1),
        productCategory: null,
        fromYear: null,
        toYear: null,
      },
    ]);
    console.log(specialTables);
  };

  const handleRemoveSpecialTable = (index) => {
    const newSpecialTables = [...specialTables];
    newSpecialTables.splice(index, 1);
    mainForm.setFieldValue("specialTables", newSpecialTables);
  };

  return (
    <Tabs defaultValue="default" mb={200} variant="outline">
      <Tabs.List>
        <Center w={50}>
          <IconCirclePlus
            size={20}
            onClick={handleAddTable}
            style={{ cursor: "pointer" }}
          />
        </Center>
        <Tabs.Tab value="default">{t("Main")}</Tabs.Tab>

        {specialTables &&
          specialTables.map((table, index) => (
            <Tabs.Tab value={`special-${index}`}>
              <Group>
                {table.name}
                <ActionIcon
                  size="xs"
                  onClick={() => handleRemoveSpecialTable(index)}
                >
                  <IconCircleX size={14} />
                </ActionIcon>
              </Group>
            </Tabs.Tab>
          ))}
      </Tabs.List>
      <Tabs.Panel value="default" p={"md"} pt={50}>
        <OverridingTable form={mainForm} name={"table"} />
      </Tabs.Panel>

      {specialTables &&
        specialTables?.map((table, index) => (
          <Tabs.Panel value={`special-${index}`} p={"md"} pt={50}>
            <OverridingTable
              form={mainForm}
              isSpecial={true}
              specialTableIndex={index}
            />
          </Tabs.Panel>
        ))}
    </Tabs>
  );
};

export default OverridingTables;
